import { create } from "zustand";

interface SessionState {
  isUnlocked: boolean;
  setUnlocked: (unlocked: boolean) => void;
}

export const useSessionStore = create<SessionState>((set) => ({
  isUnlocked: false,
  setUnlocked: (unlocked) => set({ isUnlocked: unlocked }),
}));
